import React from 'react';
import PropTypes from 'prop-types';
import { Spin, Icon } from 'antd';
import styled from 'styled-components';
import colors from './colors';

export const AppWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const MainScreen = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const AppContent = styled.div`
  width: 84%;
  max-width: 1600px;
  margin: 0 auto;
  flex: 1;
`;

export const Buffer = styled.div`
  height: ${({ height }) => height || '1px'};
  width: ${({ width }) => width || '1px'};
`;

export const CenteredWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Logo = styled.div`
  width: 300px;
  height: 150px;
  background: ${({ logo }) => `url("${logo}") no-repeat center / contain`};
  margin-bottom: 40px;
`;

export const Loading = ({ size, style }) => {
  const wrapperStyle = style || {
    width: '100%',
    textAlign: 'center',
    padding: '20px 0',
  };

  return (
    <div style={wrapperStyle}>
      <Spin style={{ transformOrigin: 'center', transform: `scale(${size})` }} />
    </div>
  );
};

Loading.defaultProps = {
  size: 1.0,
  style: null,
};

Loading.propTypes = {
  size: PropTypes.number,
  style: PropTypes.object, // eslint-disable-line
};

export const LoadingOverlay = ({
  hasData,
  top,
  height,
  minHeight,
  alpha,
}) => {
  const wrapperStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: hasData ? 'absolute' : null,
    width: '100%',
    background: `rgba(255, 255, 255, ${alpha})`,
    zIndex: 100,
    left: 0,
    height,
    minHeight,
    top,
  };

  return (
    <div style={wrapperStyle}>
      <Loading />
    </div>
  );
};

LoadingOverlay.defaultProps = {
  hasData: false,
  top: '0',
  height: '100%',
  minHeight: null,
  alpha: 0.6,
};

LoadingOverlay.propTypes = {
  hasData: PropTypes.bool,
  top: PropTypes.string,
  height: PropTypes.string,
  minHeight: PropTypes.string,
  alpha: PropTypes.number,
};

export const ClearSearchButton = styled((props) => <Icon {...props} type="close-circle" theme="filled" />)`
  cursor: pointer;
  margin-right: 5px;
  color: ${colors.LighterGray};
`;

export const Footer = styled.div`
  border-top: 2px solid #e3e3e3;
  padding-top: 25px;
  padding-bottom: 15px;
  background-color: #444;
  box-sizing: border-box;
  height: 67px;
  flex-shrink: 0;
  width: 100%;
  position: static;
`;

export const PageHeader = styled.div`
  position: ${({ sticky }) => sticky ? 'sticky' : 'static'};
  top: ${({ sticky }) => sticky ? '60px' : 'auto'};
  z-index: ${({ sticky }) => sticky ? '10' : '1'};
  background-color: #f0f2f5;
  border-bottom: 1px solid #e8e8e8;
  padding: 12px 0;
  width: 100%;
  margin-top: ${({ sticky }) => sticky ? '0' : '60px'};
`;

export const PageHeaderContent = styled.div`
  width: 84%;
  max-width: 1600px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PageHeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MainContent = styled.div`
  flex: 1;
  width: 100%;
  position: relative;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
`;

export const LoginWrapper = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

export const LoginScreen = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
